import { GatsbyImage } from "gatsby-plugin-image"
import HTMLReactParser from "html-react-parser"
import React from "react"

import RichText from "./richText/Parser"

export default function ContactBlock({ component }) {
  const { client, richtitle } = component
  const {
    title,
    clientAttributes: {
      gallery,
      testimonial: { quote, job, firstname, lastname },
    },
  } = client
  return (
    <div className="bg-opal-500">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="max-w-4xl">
          {richtitle && (
            <RichText stringHtml={richtitle} option="brightSectionTitle" />
          )}
        </div>
        <div className="mt-4 md:mt-8 grid gap-y-4 gap-x-4 grid-cols-2  sm:grid-cols-4 xl:gap-x-2">
          {gallery &&
            gallery.map(image => (
              <div key={image} className="group relative">
                <div className="w-full bg-gray-200 aspect-w-1  rounded-md overflow-hidden h-28 sm:h-24 md:h-28 lg:h-32 xl:h-40">
                  <GatsbyImage
                    image={image.localFile.childImageSharp.gatsbyImageData}
                    alt={image.altText}
                    className="w-full h-full object-center object-cover lg:w-full lg:h-full"
                  />
                </div>
              </div>
            ))}
        </div>
        <div className="mt-6 md:mt-10">
          <div className="flex text-white font-light	 italic text-2xl tracking-tight lg:text-3xl ">
            « {HTMLReactParser(quote)} »
          </div>
          <div className="block mt-2 md:mt-4">
            <div className="block uppercase text-charlestonGreen-500  text-lg lg:text-2xl">
              {firstname} {lastname}
            </div>
            <div className="block">
              {job} chez <br /> {title}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
